import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
// Modules
import { CouponStep, PartnershipStep } from '../../../redux/reducers/api-types';

interface FidStepProps extends WithTranslation {
    step?: CouponStep | PartnershipStep;
}

const FidStep = (props: FidStepProps): JSX.Element => {
    const classes = useStyles();
    const { t, step } = props;
    const { threshold, reward_type } = step;
    const couponStep = step as CouponStep;
    const partnershipStep = step as PartnershipStep;
    let content = null;
    if (couponStep.strategy) {
        const { strategy, value, validity } = couponStep;
        content = `${value}${t(`communication.fid.form.step.strategy.${strategy}`)} 
        ${validity ? ` ${t('communication.fid.form.step.validity_detail', { time: validity })}` : ''}`;
    } else if (partnershipStep.link) {
        const { link } = partnershipStep;
        content = `${link}`;
        // content = <a href={link}>{link}</a>;
    }

    return (
        <>
            <div className={classes.content}>
                <b>{t(`communication.fid.form.step.reward.${reward_type}`)}</b>
                <span>
                    {`, ${t('communication.fid.form.ride_count_from', {
                        from: threshold,
                    })}${content ? ` -> ${content}` : ''}`}
                </span>
            </div>
        </>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: { flex: 1 },
        mail: { marginRight: 16 },
    }),
);

export default withTranslation(['company', 'common'])(FidStep);
